<template>
  <div class="all_part">
    <div class="head">
      <div class="Logo">
        <img src="../assets/Main_menu_img/main_menu_title_Logo.png" alt="" />
      </div>
    </div>
    <div class="back_button">
        <div class="back" @click="back">
          <span>返回上一层</span>
        </div>
    </div>
    <div class="main_button">
      <div class="JiaGeKuCun">
        <div class="button" @click="BiaoZhunWuLiao">
          <img src="../assets/Second_menuComputer_img/BiaoZhun.png" alt="" width="70px"/>
          <span>竞品信息登记</span>
        </div>
        <div class="button" @click="FeiBiaoZhunWuLiao">
          <img src="../assets/Second_menuComputer_img/FeiBiao.png" alt=""  width="70px"/>
          <span>竞品信息查询</span>
        </div>

<!--        <div class="button">-->
<!--          <img src="../assets/Main_menu_img/YingShouKuanYuFaPiao.png" alt="" />-->
<!--          <span>财务信息</span>-->
<!--        </div>-->
<!--        <div class="button">-->
<!--          <img src="../assets/Main_menu_img/YingShouKuanYuFaPiao.png" alt="" />-->
<!--          <span>协调工作任务管理</span>-->
<!--        </div>-->
      </div>
    </div>
    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>
<!--productTablePahone-->
<script>
export default {
    name: "second_menuComputer_ICProductInfo",
  data() {
    return {

    };

  },
  methods:{
    back(){
        this.$router.push("/Main_menuComputer")
    },
    BiaoZhunWuLiao(){
      this.$router.push("/CompetitionRegistration");
    },
    // PushJiaGe(){
    //   this.$router.push("/productTable");
    // },
    FeiBiaoZhunWuLiao(){
      this.$router.push("/Competition_table");
    },
    PushRenWu(){
      this.$router.push("/productTable");
    },
    PushCaiWu(){
      this.$router.push("/productTable");
    }
  }
};
</script>

<style>
</style>
<style scoped>
.all_part {
  background-image: url("../assets/Main_menu_img/BG.png");
  background-position: bottom left;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}
.head {
  background-image: url("../assets/Main_menu_img/menu_title_bg.png");
  display: flex;
  justify-content: center;
}
.main_button {
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 70%;
}
.JiaGeKuCun {
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  width: 80%;
}
.Logo {
  margin-top: 30px;
}
.button {
  flex-direction: column;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 200px;
  width: 200px;
  background-color: #18a575;
  border-radius: 6px;
}
.button span {
  font-weight: 600;
  color: #ffffff;
  font-size: 20px;
  margin-top: 30px;
}
.Copyright_information {
  margin-bottom: 15px;
}
.back_button{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 30px;
}
.back{
  border: #18a575 1px solid;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 40px;
  align-items: center;
  border-radius: 25px;
  color: #18a575;
  width: 120px;
  margin-right: 30px;
}

</style>
